import UpdateAction from "./UpdateAction.js";
import CreateAction from "./CreateAction.js";
import PauseFirmwareRelease from "./firmwareRelease/PauseFirmwareRelease.js";
import ResumeFirmwareRelease from "./firmwareRelease/ResumeFirmwareRelease.js";
import StopFirmwareRelease from "./firmwareRelease/StopFirmwareRelease.js";
import ReleaseFirmware from "./deviceGroup/ReleaseFirmware.js";
import { install } from "./PluginSetup.js";
export default {
  UpdateAction,
  CreateAction,
  PauseFirmwareRelease,
  ResumeFirmwareRelease,
  StopFirmwareRelease,
  ReleaseFirmware,
  install
};